import React from 'react';
import { ReceiveItem } from '../receivingTypes';
import styles from './ReceiveItemRow.module.css';

interface ReceiveItemRowProps {
  item: ReceiveItem;
  onItemChange: (id: string, field: string, value: string | boolean) => void;
}

export const ReceiveItemRow: React.FC<ReceiveItemRowProps> = ({ item, onItemChange }) => {
  return (
    <div className={styles.card}>
      <div className={styles.row}>
        <div className={styles.productInfo}>
          <p className={styles.productName}>{item.productName}</p>
          <p className={styles.sku}>SKU: {item.sku}</p>
        </div>

        <div className={styles.field}>
          <p className={styles.label}>Expected</p>
          <p className={styles.expectedValue}>{item.expectedQty}</p>
          <p className={styles.sku}>{item.alreadyReceived} received</p>
        </div>

        <div className={styles.field}>
          <p className={styles.label}>Receiving now</p>
          <input
            type="number"
            min={0}
            className={styles.input}
            value={item.receivedQty}
            onChange={(e) => onItemChange(item.id, 'receivedQty', e.target.value)}
            placeholder="0"
          />
        </div>

        <div className={styles.field}>
          <p className={styles.label}>Batch/Lot</p>
          <input
            type="text"
            className={styles.input}
            value={item.batchLot}
            onChange={(e) => onItemChange(item.id, 'batchLot', e.target.value)}
            placeholder=""
          />
        </div>
      </div>

      <div className={styles.row}>
        <div className={styles.field}>
          <p className={styles.label}>Expiry Date</p>
          <input
            type="date"
            className={styles.input}
            value={item.expiryDate}
            onChange={(e) => onItemChange(item.id, 'expiryDate', e.target.value)}
          />
        </div>

        <div className={styles.field}>
          <p className={styles.label}>Location</p>
          <input
            type="text"
            className={styles.input}
            value={item.location}
            onChange={(e) => onItemChange(item.id, 'location', e.target.value)}
            placeholder="e.g., A-01"
          />
        </div>

        <div className={styles.checkboxField}>
          <input
            type="checkbox"
            className={styles.checkbox}
            checked={item.damaged}
            onChange={(e) => {
              const checked = e.target.checked;
              onItemChange(item.id, 'damaged', checked);
              // Default the damaged qty to the full received qty when first
              // checked (the common case — a whole case arrived damaged);
              // clear it when unchecked so it's never sent.
              onItemChange(item.id, 'damagedQty', checked ? (item.damagedQty || item.receivedQty || '') : '');
            }}
            id={`damaged-${item.id}`}
          />
          <label htmlFor={`damaged-${item.id}`} className={styles.checkboxLabel}>
            Damaged items
          </label>
        </div>

        {item.damaged && (
          <div className={styles.field}>
            <p className={styles.label}>Damaged Qty</p>
            <input
              type="number"
              min={0}
              max={Number(item.receivedQty) || undefined}
              className={styles.input}
              value={item.damagedQty}
              onChange={(e) => onItemChange(item.id, 'damagedQty', e.target.value)}
              placeholder="0"
            />
          </div>
        )}

        <div className={styles.fieldWide}>
          <p className={styles.label}>Notes</p>
          <input
            type="text"
            className={styles.input}
            value={item.notes}
            onChange={(e) => onItemChange(item.id, 'notes', e.target.value)}
            placeholder=""
          />
        </div>
      </div>
    </div>
  );
};
